module.exports = __webpack_public_path__ + "img/member-icon-2.02f0fb0e.png";